import React, { useState } from "react";
import ProjectCard, { ProjectCardProps } from "./ProjectCard";
import { Button } from "@/components/ui/button";

const Projects: React.FC = () => {
  const [filter, setFilter] = useState<string>("all");

  // Example project data
  const projectsData: ProjectCardProps[] = [
    {
      title: "Mobile Banking Application",
      description:
        "Secure banking app with user authentication, real-time transaction updates, and KYC workflows. Led a team of 4 developers as Product Lead.",
      image:
        "https://images.unsplash.com/photo-1563013544-824ae1b704d3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1352&q=80",
      technologies: [
        "React Native",
        "Expo",
        "Maestro",
        "TailwindCSS",
        "Storybook",
      ],
      demoUrl: "https://example.com",
      repoUrl: "https://github.com",
      featured: true,
    },
    {
      title: "Medical Practice Management System",
      description:
        "Comprehensive SaaS platform for medical practices with multi-profile support, document templates, real-time Kanban board, and statistics dashboard.",
      image:
        "https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=1504&q=80",
      technologies: ["Next.js", "WebSocket", "Tailwind CSS", "Docker"],
      demoUrl: "https://example.com",
      repoUrl: "https://github.com",
      featured: true,
    },
    {
      title: "Multi-tenant Brand Management CMS",
      description:
        "Custom CMS solution for Poujoulat with multi-tenancy capabilities, including a custom plugin for Strapi and Next.js frontend integration.",
      image:
        "https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-1.2.1&auto=format&fit=crop&w=1504&q=80",
      technologies: ["Strapi", "Next.js", "Docker", "GitLab CI"],
      demoUrl: "https://example.com",
      repoUrl: "https://github.com",
      featured: true,
    },
    {
      title: "Google Meet Clone",
      description:
        "Learning project built to understand real-time video and audio communication technologies using WebRTC.",
      image:
        "https://images.unsplash.com/photo-1612287230202-1ff1d85d1bdf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1504&q=80",
      technologies: ["Next.js", "Clerk", "Stream", "WebRTC"],
      demoUrl: "https://example.com",
      repoUrl: "https://github.com",
    },
    {
      title: "Notion Clone",
      description:
        "Project exploring real-time collaborative document editing features and complex state management.",
      image:
        "https://images.unsplash.com/photo-1512758017271-d7b84c2113f1?ixlib=rb-1.2.1&auto=format&fit=crop&w=1504&q=80",
      technologies: ["Next.js", "Clerk", "React"],
      demoUrl: "https://example.com",
      repoUrl: "https://github.com",
    },
    {
      title: "Adawat AI Platform",
      description:
        "Arabic-focused tools platform developed at Joodek, providing various AI-powered utilities for Arabic language processing.",
      image:
        "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?ixlib=rb-1.2.1&auto=format&fit=crop&w=1504&q=80",
      technologies: ["NuxtJS", "Laravel", "Docker"],
      demoUrl: "https://example.com",
      repoUrl: "https://github.com",
    },
  ];

  // Get all unique technologies
  const allTechnologies = Array.from(
    new Set(projectsData.flatMap((project) => project.technologies))
  );

  // Filter projects based on selected technology
  const filteredProjects =
    filter === "all"
      ? projectsData
      : projectsData.filter((project) => project.technologies.includes(filter));

  return (
    <section id="projects" className="py-20 bg-gray-50">
      <div className="container-custom">
        <h2 className="section-title">My Projects</h2>

        <div className="mb-10 overflow-x-auto">
          <div className="flex space-x-2 pb-2">
            <Button
              variant={filter === "all" ? "default" : "outline"}
              onClick={() => setFilter("all")}
              className={filter === "all" ? "bg-portfolio-blue text-white" : ""}
            >
              All
            </Button>

            {allTechnologies.map((tech) => (
              <Button
                key={tech}
                variant={filter === tech ? "default" : "outline"}
                onClick={() => setFilter(tech)}
                className={
                  filter === tech ? "bg-portfolio-blue text-white" : ""
                }
              >
                {tech}
              </Button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredProjects.map((project, index) => (
            <ProjectCard key={index} {...project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
